
import DataHelpers from './DataHelpers'
import FireData from '../data/FireData';
import NiceData from '../data/NiceData';

export default class {

    

    static renameTransaction (transactionKey, description) {
        if(!transactionKey) {
            console.error('No transaction to update')
            return
        }
        if(!description) {
            console.error('No description to update')
            return
        }

        let tenantRef = DataHelpers.getTenantRef()
        let transactionRef = tenantRef.child('transactions/' + transactionKey)

        let contactRef = transactionRef.child('elements').orderByChild('type').equalTo('Contact')
            
        FireData.fetchItems(contactRef).then(contactElements => {
            contactElements.filter(o => o.role == 'Client').forEach(contactElement => {
                tenantRef.child('contactTransactions/' + contactElement.contactKey + '/' + transactionKey).child('description').set(description)
            })
            
            transactionRef.child('details').child('description').set(description)
        })
 
    }

    static deleteTransaction (transactionKey) {
        if(!transactionKey) {
            console.error('No transaction to delete')
            return
        }

        let tenantRef = DataHelpers.getTenantRef()
        let transactionRef = tenantRef.child('transactions/' + transactionKey)

        let contactRef = transactionRef.child('elements').orderByChild('type').equalTo('Contact')
            
        FireData.fetchItems(contactRef).then(contactElements => {
            contactElements.filter(o => o.role == 'Client').forEach(contactElement => {
                
                tenantRef.child('contactTransactions/' + contactElement.contactKey + '/' + transactionKey).remove()
            })
            
            transactionRef.remove()
        })
 
    }

    static makeTemplate (transactionKey) {
        return new Promise( (resolve, reject) => {
            if(!transactionKey) {
                console.error('No transaction to make into template')
                return
            }
    
            const tenantRef = DataHelpers.getTenantRef()
            const transactionRef = tenantRef.child('transactions/' + transactionKey + '/details')
            transactionRef.child('isTemplate').set(true)
            
            NiceData.fetchItemSingle(transactionRef).then(transactionDetails => {
    
                transactionRef.child('originalMasterKey').set(transactionDetails.masterKey)
                transactionRef.child('masterKey').set(transactionKey)
                const transactionTemplatesRef = tenantRef.child('transactionTemplates').child(transactionKey)
                transactionTemplatesRef.update({
                    clients: transactionDetails.clients,
                    description: transactionDetails.description,
                }).then(result => {
                    resolve(result)
                })
            })                    
        })


    }

    static removeTemplate (transactionKey) {
        return new Promise( (resolve, reject) => {
            if(!transactionKey) {
                console.error('No transaction to remove from template')
                return
            }
    
            const tenantRef = DataHelpers.getTenantRef()
            const transactionRef = tenantRef.child('transactions/' + transactionKey + '/details')
            
            transactionRef.child('isTemplate').remove()
    
            NiceData.fetchItemSingle(transactionRef).then(transactionDetails => {
                transactionRef.child('masterKey').set(transactionDetails.originalMasterKey)
                transactionRef.child('originalMasterKey').remove
            })
    
            const transactionTemplatesRef = tenantRef.child('transactionTemplates').child(transactionKey)
            transactionTemplatesRef.remove()   
            
            setTimeout( () => {
                resolve('template removed')
            },500)
          
        })


    }
    
}


// WEBPACK FOOTER //
// ./src/helpers/TransactionHelpers.js